import { useMemo } from "react";
import { getRequiredNameFields } from "./getRequiredNameFields";
import type { RequiredNameFields } from "./getRequiredNameFields";
import { useMetadataQuery } from "./useMetadataQuery";

/** React binding for {@link getRequiredNameFields}, memoized against the current form metadata. */
export const useRequiredNameFields = (): RequiredNameFields => {
    const { data: formMetadata } = useMetadataQuery();

    return useMemo(() => getRequiredNameFields(formMetadata), [formMetadata.fieldGroupsAndFeatureContainers]);
};
